// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__dOBCu","alert":"SettungsInbox_alert__1Rppd"};